import React from 'react';
import HubModelCard from './HubModelCard';

/**
 * HubModelsGrid
 *
 * Grid of Hugging Face Hub search hits. Mirrors RecommendedModelsGrid so the
 * Discover tab can stack "recommended" and "hub results" with identical
 * chrome.
 */
function HubModelsGrid({ models, onCardClick, emptyMessage }) {
  if (!models || models.length === 0) {
    return (
      <div className="desktop-models-grid-empty">
        <div className="desktop-empty-icon">
          <i className="fa-solid fa-search" />
        </div>
        <h3>No Results</h3>
        <p>{emptyMessage || 'Try a different query or clear the search.'}</p>
      </div>
    );
  }

  return (
    <div className="desktop-models-grid">
      {models.map((m) => (
        <HubModelCard key={m.id} model={m} onCardClick={onCardClick} />
      ))}
    </div>
  );
}

export default HubModelsGrid;
